var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"wrapper"},[_c('img',{staticStyle:{"width":"120px"},attrs:{"src":require("@/assets/invoiceUploadV2SuccessFromEit.png")}}),_c('div',{staticClass:"text"},[_vm._v("数据授权已完成，请前往上传数据")])])])
}]

export { render, staticRenderFns }